import React, { useState, useEffect, memo } from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

const GoogleMapComponent = memo(({ activeTab }) => {
  const [mapLoaded, setMapLoaded] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulating map loading with a delay
    const loadingTimeout = setTimeout(() => {
      setMapLoaded(true);
    }, 2000); // Adjust the timeout duration based on your estimation

    // Simulating loading progress
    const progressInterval = setInterval(() => {
      setProgress((oldProgress) => {
        const diff = Math.random() * 80; // Simulate progress increase
        return Math.min(oldProgress + diff, 100); // Cap the progress at 100
      });
    }, 500); // Adjust the interval based on your estimation

    // Cleanup functions to clear timeouts and intervals
    return () => {
      clearTimeout(loadingTimeout);
      clearInterval(progressInterval);
    };
  }, []);

  if (!mapLoaded) {
    // Render loading indicator while the map is loading
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          visibility:
            activeTab === "vehicle" || activeTab === "driver"
              ? "hidden"
              : "visible",
          zIndex:
            activeTab === "vehicle" || activeTab === "driver" ? "-1" : "100",
          position:
            activeTab === "vehicle" || activeTab === "driver" ? "" : "absolute",
          top: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
          left: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
          right: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
          bottom: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
        }}
      >
        <Box sx={{ width: "50%" }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
      </div>
    );
  }

  return (
    <iframe
      title="Google Maps"
      width="100%"
      height="100%"
      src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;coord=52.70967533219885, -8.020019531250002&amp;q=1%20Grafton%20Street%2C%20Dublin%2C%20Ireland&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed"
      frameBorder="0"
      scrolling="no"
      style={{
        visibility:
          activeTab === "vehicle" || activeTab === "driver"
            ? "hidden"
            : "visible",
        zIndex:
          activeTab === "vehicle" || activeTab === "driver" ? "-1" : "100",
        position:
          activeTab === "vehicle" || activeTab === "driver" ? "" : "absolute",
        top: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
        left: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
        right: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
        bottom: activeTab === "vehicle" || activeTab === "driver" ? "" : "0",
      }}
      loading="lazy"
    ></iframe>
  );
});

export default GoogleMapComponent;
